import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService extends TitleStrategy {
  constructor(
    private translateService: TranslateService,
    private title: Title,
    private store: Store
  ) {
    super();
  }

  async updateTitle(snapshot: RouterStateSnapshot): Promise<void> {
    const title = this.buildTitle(snapshot) || '';

    if (!title) {
      console.error('Title is not set');
      return;
    }

    this.title.setTitle(this.translateService.instant(title));
  }
}
